import type { Messages } from '../en'

export const runs: Messages['runs'] = {
  // ActiveRunsPage
  activeTitle: 'Execuções ativas',
  activeSubtitle: 'Execuções em andamento e tudo que aguarda sua resposta.',
  live: 'ao vivo',
  activeEmpty: 'Nada ativo no momento. Inicie um fluxo para vê-lo aqui.',
  // `when` is a relative phrase from formatAgo ("há 5 min") — no preposition here.
  startedAt: (when) => `iniciada ${when}`,
  needsReply: 'Precisa da sua resposta',
  running: 'em execução',
  answer: 'Responder',
  watch: 'Acompanhar',

  // ConversationsPage
  historyTitle: 'Histórico',
  historySubtitle: 'Todas as suas execuções e conversas anteriores.',
  filterByFlow: 'Filtrar por fluxo',
  allFlows: 'Todos os fluxos',
  filterByStatus: 'Filtrar por status',
  anyStatus: 'Qualquer status',
  clearFilters: 'Limpar filtros',
  loadingHistory: 'Carregando histórico…',
  emptyFiltered: 'Nenhuma execução corresponde a estes filtros ainda.',
  emptyNoConversations: 'Nenhuma conversa ainda. Inicie um fluxo para começar.',
  emptySoFar: 'Nada a mostrar entre as execuções mais recentes. Carregue mais para ver as anteriores.',
  loadMore: 'Carregar mais',
  deliverableFilesTitle: (n) => (n === 1 ? '1 arquivo de entrega' : `${n} arquivos de entrega`),

  // Shared status-code → label (history dropdown + row badges)
  statusLabel: (status) => {
    switch (status) {
      case 'success':
        return 'Concluída'
      case 'partial_success':
        return 'Parcial'
      case 'failure':
        return 'Falhou'
      case 'awaiting_user_response':
        return 'Aguardando resposta'
      default:
        return 'Em execução'
    }
  }
}
